import { render, staticRenderFns } from "./MaxRoleCreate.vue?vue&type=template&id=d8461b5a&scoped=true"
import script from "./MaxRoleCreate.vue?vue&type=script&lang=js"
export * from "./MaxRoleCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8461b5a",
  null
  
)

export default component.exports